export default "__VITE_ASSET__CMVH0kPJ__"